module.exports = __webpack_public_path__ + "assets/img/solar-panels-3.18d76fd2.jpg";